export default __webpack_public_path__ + "static/media/Safe-Black.5292a209.png";